import React from "react";
import { RxCounterClockwiseClock } from "react-icons/rx";
import ScrollAnimation from 'react-animate-on-scroll';
import SpeacersFon from '../../img/speacers_fon.webp'
import 'animate.css';
import DOMPurify from "dompurify";

const EventProgram = ({ programData = [] }) => {
    if (!programData.length) return null;

    return (
        <section className="py-20" id="programm">
            <div className="container max-w-screen-xl mx-auto pb-8 px-4">

                <ScrollAnimation animateIn="animate__fadeInUp">
                    <h2 className="font-bold uppercase text-3xl text-[#245864] mb-6
                                sm:text-4xl lg:text-left lg:text-[60px]">Програма 2025</h2>
                    {/*<p className="mb-[75px]">* Програма формується. Слідкуйте за оновленнями</p>*/}
                </ScrollAnimation>
                {programData.map((item, index) => {
                    return item.acf.program_fields.map((layoutData, subIndex) => {
                        const {program_time, select_field} = layoutData;
                        return (
                            <div key={subIndex}
                                 className={`program-item p-3 ${subIndex % 2 == 0 ? 'bg-[#95C8BF]/10 ' : ''} rounded-[8px]`}>
                                {/** время и темы **/}
                                <div className="program-header md:flex md:flex-wrap items-center gap-[15px]">
                                    {
                                        program_time ?
                                            <div className="flex md:mb-0 mb-2 w-[130px] items-center gap-[10px] text-black font-medium">
                                                <RxCounterClockwiseClock className="text-[#002CBA]/60"/>{program_time}
                                            </div> : ''
                                    }

                                    <div className="sm:w-[calc(100%-150px)] w-full max-sm:mb-2">
                                        {select_field.map((field, fieldIndex) => {
                                            const theme = field.acf_fc_layout === "panel_discussion" ? field.theme_panell :
                                                field.acf_fc_layout === "panel_сollective" ? field.theme_сollective :
                                                    field.acf_fc_layout === "public_interview" ? field.theme_interview :
                                                        field.acf_fc_layout === "single_speacer" ? field.theme :
                                                            field.acf_fc_layout === "coffee_break" ? field.break_title : null;
                                            return theme ? <h3 key={fieldIndex}
                                                               className="sm:text-xl text-[18px] font-semibold leading-tight"
                                                               dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(theme, {sanitize: true})}}/> : null;
                                        })}
                                    </div>
                                </div>

                                {/** Блоки **/}
                                {select_field.map((field, fieldIndex) => {
                                    switch (field.acf_fc_layout) {
                                        case "panel_discussion":
                                            return (
                                                <div key={fieldIndex}
                                                     className="panel-discussion grid lg:grid-cols-6 grid-cols-2 gap-4 sm:py-4">

                                                    {
                                                        field.thesises_panell ?
                                                            <div
                                                                className="thesises-panel font-normal gap-4 lg:order-2 col-span-2">
                                                                <div className="text-justify text-[14px] thesis-list"
                                                                     dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(field.thesises_panell, {sanitize: true})}}/>
                                                            </div> : ''
                                                    }


                                                    <div className="speakers grid lg:grid-cols-3 sm:grid-cols-2 lg:col-span-4 col-span-3 sm:gap-4 gap-2">
                                                        {field.speacers?.length > 0 && field.speacers.map((speaker, speakerIndex) => (
                                                            <div key={speakerIndex} className="speaker last:mb-0
                                                                border p-4 rounded-lg border-[#245864]">
                                                                <div className="flex items-start gap-3 mb-2">
                                                                    <div
                                                                        className="speaker-foto w-20 shrink-0">
                                                                        <img
                                                                            src={speaker.acf.sm_image}
                                                                            className="w-full h-full object-cover rounded-lg bg-gray-200/60"
                                                                            style={{backgroundImage: `url(${SpeacersFon})`,backgroundSize: "cover",backgroundPosition: "left top"}}
                                                                            alt={speaker.post_title}
                                                                        />
                                                                        {speakerIndex === 0 && (
                                                                            <span className="bg-black text-white text-xs px-2 py-1 rounded-lg">
                                                                            Модератор
                                                                        </span>
                                                                        )}
                                                                    </div>
                                                                    <div
                                                                        className="speaker-info flex flex-col gap-2">
                                                                        <h4 className="text-[14px]">{speaker.post_title}</h4>
                                                                        {speaker.acf.logo && (
                                                                            <img
                                                                                src={speaker.acf.logo}
                                                                                alt="Speaker logo"
                                                                                className=""
                                                                                style={{width: `${speaker.acf.logo_mw || 40}px`}}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <p className="text-[12px] text-[#333]">{speaker.acf.position}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        case "panel_сollective":
                                            return (
                                                <div key={fieldIndex}
                                                     className="panel-discussion flex flex-col lg:flex-row-reverse gap-4 sm:py-4">

                                                    {
                                                        field.thesises_сollective ?
                                                            <div
                                                                className="thesises-panel font-normal lg:w-2/5 sm:mb-0 mb-4">
                                                                <div className="text-justify text-[14px] thesis-list"
                                                                     dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(field.thesises_сollective, {sanitize: true})}}/>

                                                            </div> : ''
                                                    }


                                                    <div className="speakers flex-1 gap-5 md:flex md:flex-wrap">
                                                        {field.speacers?.length > 0 && field.speacers.map((speaker, speakerIndex) => (
                                                            <div key={speakerIndex} className="speaker mb-3 md:w-[48%] xl:w-[31%]
                                                                border p-4 rounded-lg border-[#245864]">
                                                                <div className="flex items-start gap-3 mb-2">
                                                                    <div
                                                                        className="speaker-foto w-20 shrink-0">
                                                                        <img
                                                                            src={speaker.acf.sm_image}
                                                                            className="w-full h-full object-cover rounded-lg bg-gray-200/60"
                                                                            style={{backgroundImage: `url(${SpeacersFon})`,backgroundSize: "cover",backgroundPosition: "left top"}}
                                                                            alt={speaker.post_title}
                                                                        />
                                                                    </div>
                                                                    <div
                                                                        className="speaker-info flex flex-col gap-2">
                                                                        <h4 className="text-[14px]">{speaker.post_title}</h4>
                                                                        {speaker.acf.logo && (
                                                                            <img
                                                                                src={speaker.acf.logo}
                                                                                alt="Speaker logo"
                                                                                className=""
                                                                                style={{width: `${speaker.acf.logo_mw || 40}px`}}
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <p className="text-[12px] text-[#333]">{speaker.acf.position}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        case "public_interview":
                                            return (
                                                <div key={fieldIndex}
                                                     className="panel-discussion flex flex-col lg:flex-row-reverse gap-4 sm:py-4">
                                                    {
                                                        field.thesises_panell ?
                                                            <div
                                                                className="thesises-panel font-normal lg:w-2/5 sm:mb-0 mb-4">
                                                                <div className="text-justify text-[14px] thesis-list"
                                                                     dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(field.thesises_panell, {sanitize: true})}}/>

                                                            </div> : ''
                                                    }

                                                    <div className="speakers flex-1 gap-5 md:flex md:flex-wrap">
                                                        {field.speacers?.length > 0 && field.speacers.map((speaker, speakerIndex) => (
                                                            <div key={speakerIndex} className="speaker mb-3 md:w-[48%] xl:w-[31%] flex items-start gap-3
                                                                border p-4 rounded-lg border-[#245864]">
                                                                <div
                                                                    className="speaker-foto w-20 shrink-0">
                                                                    <img
                                                                        src={speaker.acf.sm_image}
                                                                        className="w-full h-full object-cover rounded-lg bg-gray-200/60"
                                                                        style={{backgroundImage: `url(${SpeacersFon})`,backgroundSize: "cover",backgroundPosition: "left top"}}
                                                                        alt={speaker.post_title}
                                                                    />
                                                                    {speakerIndex === 0 && (
                                                                        <span className="
                                                                         bg-black text-white text-xs px-2 py-1 rounded-tr-lg">
                                                                            Інтерв'юер
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <div className="speaker-info flex flex-col gap-2">
                                                                    <h4 className="text-[14px]">{speaker.post_title}</h4>
                                                                    {speaker.acf.logo && (
                                                                        <img
                                                                            src={speaker.acf.logo}
                                                                            alt="Speaker logo"
                                                                            className=""
                                                                            style={{width: `${speaker.acf.logo_mw || 40}px`}}
                                                                        />
                                                                    )}
                                                                    <p className="text-[12px] text-[#333]">{speaker.acf.position}</p>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            );
                                        case "single_speacer":
                                            return (
                                                <div key={fieldIndex}
                                                     className="single-speacer grid lg:grid-cols-6 gap-4 sm:py-4">

                                                    {field.speacer.map((speaker, speakerIndex) => (
                                                        <div key={speakerIndex} className="speakers grid lg:grid-cols-9 sm:grid-cols-6 lg:col-span-6 col-span-3 sm:gap-4 gap-2">
                                                            <div className="speaker last:mb-0 border p-4 rounded-lg border-[#245864] col-span-4 flex items-start gap-3 ">
                                                                <div
                                                                    className="speaker-foto w-20 shrink-0 rounded-lg overflow-hidden">
                                                                    <img
                                                                        src={speaker.acf.sm_image}
                                                                        className="w-full h-full object-cover rounded-lg bg-gray-200/60"
                                                                        style={{backgroundImage: `url(${SpeacersFon})`,backgroundSize: "cover",backgroundPosition: "left top"}}
                                                                        alt={speaker.post_title}
                                                                    />
                                                                </div>
                                                                <div className="speaker-info flex flex-col gap-2">
                                                                    <h4 className="text-[14px]">{speaker.post_title}</h4>
                                                                    <p className="text-[12px] text-[#333]">{speaker.acf.position}</p>
                                                                    {speaker.acf.logo && (
                                                                        <img
                                                                            src={speaker.acf.logo}
                                                                            style={{width: `${speaker.acf.logo_mw ? speaker.acf.logo_mw : 40}px`}}
                                                                            alt="logo"
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {
                                                                field.thesises ?
                                                                    <div
                                                                        className="thesises-panel font-normal sm:mb-0 mb-4 col-span-7">
                                                                        <div className="text-justify text-[14px] thesis-list"
                                                                             dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(field.thesises, {sanitize: true})}}/>
                                                                    </div> : ''
                                                            }
                                                        </div>
                                                    ))}




                                                </div>
                                            );
                                        default:
                                            return null;
                                    }
                                })}
                            </div>

                        );
                    });
                })}
            </div>
        </section>
    );
};

export default EventProgram;